import React, { useState, useEffect } from "react";
import { ReactComponent as CloseSVG } from "../../../assets/close.svg";
import {
  OPContainer,
  OPBox,
  OPHeader,
  OPTitle,
  Volume,
  OPWrapper,
} from "./SettingsStyled";
import ToggleSwitch from "./ToggleSwitch";

export default ({
  handleAbove,
  handleAboveAnim,
  aboveAnim,
  handleSetting,
  aboveSettingAnim,
  handleSettingsOut,
  settingsA,
  userSettings,
  saveUserSettings,
  handleVolumeLocal,
  audio,
}) => {
  const [music, setmusic] = useState(userSettings.music);
  const [sound, setsound] = useState(userSettings.sound);
  const [volume, setvolume] = useState(userSettings.volume);
  const [closeBtn, setclosebtn] = useState(false);
  const [provAnim, setprovAnim] = useState(false);
  const [ruleAnim, setRuleAnim] = useState(false);
  const [historyAnim, setHistoryAnim] = useState(false);

  const [soundPlayed, setSoundPlayed] = useState(false);

  const setAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 500);
    }
  };

  useEffect(() => {
    setmusic(userSettings.music);
    setsound(userSettings.sound);
    setvolume(userSettings.volume);
  }, [userSettings]);
  const handleSavingSettings = (arr) => saveUserSettings(arr);
  return (
    <OPContainer
      aboveAnim={aboveSettingAnim}
      settingsA={settingsA}
      isDisabled={soundPlayed}
    >
      <OPWrapper>
        <OPBox aboveAnim={aboveSettingAnim} settingsA={settingsA}>
          <OPHeader aboveAnim={aboveAnim} close={closeBtn}>
            <p>Settings</p>
            <span
              onClick={() => {
                setAnimation(closeBtn, setclosebtn);
                setSoundPlayed(true);
                handleAboveAnim(false);
                audio.goBack();
                setTimeout(() => {
                  handleSetting(false);
                }, 100);
              }}
            >
              <CloseSVG />
            </span>
          </OPHeader>
          <OPTitle
            prov={provAnim}
            onClick={() => {
              setAnimation(provAnim, setprovAnim);
              audio.goForward();
              setTimeout(() => {
                handleAbove("provFair");
                handleAboveAnim(true);
                handleSettingsOut(true);
                handleSetting(false);
              }, 100);
            }}
          >
            Provably Fair
          </OPTitle>
          <OPTitle
            rules={ruleAnim}
            onClick={() => {
              setAnimation(ruleAnim, setRuleAnim);
              audio.goForward();
              setTimeout(() => {
                handleAbove("gameRules");
                handleAboveAnim(true);
                handleSettingsOut(true);
                handleSetting(false);
              }, 100);
            }}
          >
            Game Rules
          </OPTitle>
          <OPTitle
            history={historyAnim}
            onClick={() => {
              setAnimation(historyAnim, setHistoryAnim);
              audio.goForward();
              setTimeout(() => {
                handleAbove("history");
                handleAboveAnim(true);
                handleSettingsOut(true);
                handleSetting(false);
              }, 100);
            }}
          >
            History
          </OPTitle>
          <ToggleSwitch
            name={"Music"}
            isOn={music === "1"}
            myVolume={userSettings.volume}
            playSwitchSound={() => music === "0" && audio.switch()}
            save={() =>
              handleSavingSettings([music === "1" ? "0" : "1", sound, volume])
            }
          />
          <br />
          <ToggleSwitch
            name={"Sound"}
            isOn={sound === "1"}
            myVolume={userSettings.volume}
            playSwitchSound={() => audio.switch()}
            save={() =>
              handleSavingSettings([music, sound === "1" ? "0" : "1", volume])
            }
          />
          <br />
          <Volume
            saveUserSetting={(v) => handleSavingSettings([music, sound, v])}
            value={volume}
            handleVolumeLocal={handleVolumeLocal}
          />
        </OPBox>
      </OPWrapper>
    </OPContainer>
  );
};
